/*
 * @Author: 王文龙
 * @Date: 2024-12-19 14:24:39
 * @FileDescription: 模板文件地址集合
 */

/**
 * @description: 获取模板文件地址
 * @param {String} type 文件类型 key
 * @return {*}
 */
const getTemplateUrl = type => {
	const urls = {
		stationFile: 'https://web-resource-os.jryghq.com/police/%E5%8F%B8%E6%9C%BA%E5%90%8D%E5%8D%95.xlsx', //  场站接单管理批量上传模板文件
		couponCityIdFile: 'https://passenger-static.jryghq.com/passenger/prod/private/2025/01/07/1jPIJncRPWHNulgJR6jONHFSiVhvkF6y.csv', //  营销系统-领券活动-城市id csv文件
		messageOpenIdFile: 'https://passenger-static.jryghq.com/passenger/prod/private/2025/01/07/fDN7cnzWnXh8Mhdwnpl4NNuUOjAHPsEw.csv', //  营销系统-订阅消息触达-人群id csv文件
		batchRollbackFile: 'https://workorder-os.jryghq.com/template/扣罚回滚.xlsx', //  批量扣罚回滚模版
		nonBatchRollbackFile: 'https://workorder-os.jryghq.com/template/非扣罚回滚.xlsx', // 非批量扣罚回滚模版
		driverScoreFile: 'https://training-cos.jryghq.com/batch-template.xlsx ' // 司机分-人工加分模板
	}
	return urls[type]
}

export default getTemplateUrl
